import * as angular from "angular";

export class RegisterService {
    private apiRoot: string;
    private $http: any;

    constructor($http: any, __env: any) {
        this.$http = $http;
        this.apiRoot = __env.apiUrl() + "/house";
    }

    deleteNBImport(data: any): Promise<object> {
        return this.$http.delete(
            this.apiRoot + "/nbimport" + data.nbimportid,
            data
        );
    }
}

angular.module("vcServices").service("RegisterService", RegisterService);
